import { connect } from 'react-redux'

import { lookupEvent } from '../redux/modules/search/actions'

import EventLookup from '../components/EventLookup'

const mapStateToProps = (state) => ({
  events: state.search.events,
  fallbackEventNames : state.search.fallback_event_names
})

const actionCreators = { lookupEvent }

export default connect(mapStateToProps, actionCreators)(EventLookup)



// WEBPACK FOOTER //
// ./src/containers/EventLookup.js